import Head from 'next/head';
import Link from 'next/link';

import { GLFHApplicationProcessHelpSEO } from '@/utils/constants/MetaData';

const GoldLoanfromHomeApplicationProcess = () => {
  return (
    <>
      <Head>
        <title>{GLFHApplicationProcessHelpSEO.metaTitle}</title>
        <meta
          name="description"
          content={GLFHApplicationProcessHelpSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={GLFHApplicationProcessHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/gold-loan-from-home-application-process/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Gold Loan Prime Application Process
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Gold Loan Prime Application Process
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How can I apply for a Gold Loan Prime?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Applying for the Gold Loan Prime on the Muthoot FinCorp ONE
                    app is easy. All you need to do is follow these steps:
                    <p>
                      • Step 1: At the time of booking an appointment, select
                      the Gold Loan Prime option on the app.
                    </p>
                    <p>
                      • Step 2: Choose your residential address and preferred
                      appointment date and time.
                    </p>
                    <p>• Step 3: Confirm the appointment slot and continue.</p>
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What documents do I need to get a Gold Loan Prime?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Once your appointment is confirmed, please keep the
                    following documents ready before your dedicated Muthoot
                    FinCorp Ltd. Relationship Manager visits your home:
                    <p>• Proof of Identity</p>
                    <p>• Proof of Address</p>
                    <p>• Cancelled Cheque</p>
                    Keeping these documents handy will help ensure a faster and
                    smoother process.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Do I need a bank account to get a Gold Loan Prime?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you must have a Muthoot FinCorp Ltd. Unique Customer
                    Identification Code (UCIC) along with a valid and active
                    bank account to avail a Gold Loan. This is required as the
                    loan amount is transferred directly to the bank account
                    shared with us.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  Can I reschedule my home visit appointment?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can reschedule your home visit appointment through
                    the Muthoot FinCorp ONE app, subject to availability and
                    applicable guidelines.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default GoldLoanfromHomeApplicationProcess;
